// Authoring edits may rebuild the State runtime. Keep the user's working view
// separate from saved Camera options, which still apply when explicitly clicked.
export function captureCameraView(perspective, orthographic, camera, controls, cameraState) {
    return {
        perspective: perspective.clone(), orthographic: orthographic.clone(),
        isOrthographic: camera === orthographic, target: controls.target.clone(),
        orthographicSize: cameraState?.orthographicSize ?? 2
    };
}

export function restoreCameraView(view, perspective, orthographic, controls, state) {
    perspective.copy(view.perspective); orthographic.copy(view.orthographic);
    const camera = view.isOrthographic ? orthographic : perspective;
    controls.object = camera;
    controls.target.copy(view.target);
    controls.update();
    // Keep the exact captured orientation, including any saved camera roll.
    camera.quaternion.copy((view.isOrthographic ? view.orthographic : view.perspective).quaternion);
    camera.updateMatrixWorld(true);
    if (state) {
        state.userCamera = camera;
        state.cameraState.target.copy(view.target);
        state.cameraState.distance = camera.position.distanceTo(view.target);
        state.cameraState.orthographicSize = view.orthographicSize;
        state.innoWorksActiveAnimations = (state.innoWorksActiveAnimations ?? []).filter(animation => animation.type !== "camera");
    }
    return camera;
}

export async function preserveCameraView(viewport, action) {
    const view = viewport.captureView();
    try { return await action(); }
    finally { viewport.restoreView(view); }
}
